export enum ComponentTypes {
  PortfolioComponent = 1,
  ExperienceComponent = 2
}
